import * as firebase from "firebase";

export default {
    state: {
        user: null,
        // userData: null,
        isUserLoggedIn: false,
        isUserDataLoaded: false,
        unsavedChanges: false,
        loginSnackbar: false,
        logoutSnackbar: false,
        registrationSnackbar: false,
    },
    getters: {
        user: state => {
            return state.user;
        },
        // getUserData: state => {
        //         //     return state.userData;
        //         // },
        getIsUserLoggedIn: state => {
            return state.isUserLoggedIn;
        },
        getIsUserDataLoaded: state => {
            return state.isUserDataLoaded;
        },
        getLoginSnackbar: state => {
            return state.loginSnackbar;
        },
        getLogoutSnackbar: state => {
            return state.logoutSnackbar;
        },
        getRegistrationSnackbar: state => {
            return state.registrationSnackbar;
        },
        getUnsavedChanges: state => {
            return state.unsavedChanges;
        }
    },
    mutations: {
        setUser(state, payload) {
            state.user = payload;
        },
        clearUser(state) {
            state.user = null;
        },
        // setUserData(state, payload) {
        //     state.userData = payload;
        // },
        clearUserData(state) {
            state.userData = null;
        },
        setIsUserLoggedIn(state, payload) {
            state.isUserLoggedIn = payload;
        },
        setIsUserDataLoaded(state, payload) {
            state.isUserDataLoaded = payload;
        },
        setLogoutSnackbar(state, payload) {
            state.logoutSnackbar = payload;
        },
        setRegisterSnackbar(state, payload) {
            state.registrationSnackbar = payload;
        },
        setLoginSnackbar(state, payload) {
            state.loginSnackbar = payload;
        },
        setUnsavedChanges(state, payload) {
            state.unsavedChanges = payload;
        }
    },
    actions: {

        // payload: {username: <string>, email: <string>, password: <string>}
        signUpUser({commit, dispatch}, payload) {
            firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
                .then(response => {
                    commit('setUser', response.user);
                    firebase.auth().currentUser.updateProfile({
                        // set up user display name
                        displayName: payload.username,
                    }).then(() => {
                        firebase.firestore().collection("users").doc(response.user.uid).set({
                            decks: [],
                            collections: [],
                        }).then(() => {
                            dispatch("downloadUserData", response.user.uid); // TODO: add back in update to displayname (not displaying when user signs up)
                            commit("setRegisterSnackbar", true);
                        }).catch(err => {
                            commit("setError", err);
                            console.log(err);
                        })
                    }).catch(err => {
                        commit("setError", err);
                        console.log(err);
                    })
                }).catch(err => {
                commit("setError", err);
                console.log(err);
            })
        },

        // payload: {email: <string>, password: <string>} (Packet can be null, sign in pre-authenticated user)
        signInUser({commit, dispatch}, payload) {
            console.log("running signInUser with payload: ", payload);
            if (payload !== null) {
                firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
                    .then(data => {
                        commit('setUser', data.user);
                        dispatch("downloadUserData", data.user.uid);
                        commit("setIsUserLoggedIn", true);
                        commit("setLoginSnackbar", true);
                    }).catch(err => {
                    commit("setError", err);
                    console.log(err);
                });
            }
        },

        signOutUser({commit}) {
            firebase.auth().signOut()
                .then(() => {
                    commit("clearUser");
                    commit("clearUserData");
                    commit("setIsUserLoggedIn", false);
                    commit("setLogoutSnackbar", true);
                })
                .catch(err => {
                    commit("setError", err);
                    console.log(err);
                })
        },

        downloadUserData({commit, getters}, userUID) {
            if (getters.getIsUserDataLoaded === false) {
                firebase.firestore().collection("users").doc(userUID)
                    .onSnapshot((doc) => {
                        if (doc.data().decks) {
                            commit("setUserDecks", doc.data().decks);
                        } else {
                            commit("setUserDecks", []);
                        }
                        if (doc.data().collections) {
                            commit("setUserCollections", doc.data().collections);
                        } else {
                            commit("setUserCollections", []);
                        }
                    commit("setIsUserDataLoaded", true);
                });
            }
        },
        uploadUserData({getters}) {
            console.log(getters.getUserDecks);
            console.log(getters.getUserCollections);

            firebase.firestore().collection("users").doc(getters.user.uid)
                .set(
                    {
                        decks: getters.getUserDecks,
                        collections: getters.getUserCollections,
                    }).catch(err => {
                console.log(err);
            });
        },
    }
};
